import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

// Droits nécessaires : USER_EXPENSE ou ADMIN_INVOICE
const GET_EXPENSE_REPORT = gql`
  query ExpenseReport($uuid: ID!) {
    expenseReport(uuid: $uuid) {
      adminComment
      amountExcludingVat
      amountExcludingVatEur
      boondManagerId
      category {
        accountingAccountNumber
        label
        labelEn
        labelFr
        uuid
      }
      comment
      countryCode
      createdAt
      currency
      expenseReportFileUuid
      impactsOverflow
      invoiceDate
      invoiceIssuer
      paymentDate
      status
      totalAmount
      totalAmountEur
      user {
        email
        firstname
        gender
        language
        lastname
        trigram
        uuid
      }
      uuid
      vatList {
        vatAmount
        vatAmountEur
        vatRate
        vatUuid
      }
    }
  }
`;

export const useExpenseReport = () => {
  const [getExpenseReport, { loading, error, data, refetch }] = useLazyQuery(GET_EXPENSE_REPORT, {
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    data: data?.expenseReport,
    refetch,
    getExpenseReport: (uuid) => getExpenseReport({ variables: { uuid } }),
  };
};
